function $3e595d6bb3c29eb5$export$f78842bd8df93f12() {
    return `
    <footer class="site-footer">
      <div class="footer-brand">
        <p>womyn.network</p>
        <span>&copy; 2026 womyn.network. A social network, for women.</span>
      </div>

      <div class="footer-link-groups">
        <div class="footer-group">
          <h2>Company</h2>
          <a href="/#vision" data-route>Vision</a>
          <a href="/#pillars" data-route>Pillars</a>
        </div>
        <div class="footer-group">
          <h2>Legal</h2>
          <!-- Privacy Policy -->
          <!-- Community Guidelines -->
          <a href="/contact" data-route>Enquiries</a>
          <a href="/terms" data-route>Beta Terms</a>
        </div>
        <div class="footer-group">
          <h2>Support</h2>
          <a href="/contact" data-route>Contact Us</a>
          <a href="/#faq" data-route>FAQ</a>
        </div>
      </div>
    </footer>
  `;
}


var $0f8318c83f467e90$exports = {};
$0f8318c83f467e90$exports = import.meta.resolve("d2BzW");


function $95d0977e6dbb0c2a$export$5072548dc819e0ba() {
    return `
    <header class="site-header">
      <a class="brand" href="/" data-route aria-label="womyn.network home">
        <img src="${new URL($0f8318c83f467e90$exports).href}" alt="" aria-hidden="true">
        <span>womyn.network</span>
      </a>

      <button
        class="menu-toggle"
        type="button"
        aria-controls="primaryNav"
        aria-expanded="false"
      >
        <span></span>
        <span></span>
        <span></span>
        <span class="sr-only">Toggle navigation</span>
      </button>

      <nav class="nav" aria-label="Primary navigation">
        <div class="nav-menu" id="primaryNav">
          <a href="/#vision" data-route>Vision</a>
          <a href="/#pillars" data-route>Pillars</a>
          <a href="/#founding" data-route>Founding Myns</a>
          <a href="/#faq" data-route>FAQ</a>
          <a href="/contact" data-route>Contact Us</a>
          <a class="mobile-menu-cta" href="/#join" data-route>Join the Waitlist</a>
        </div>
      </nav>

      <a class="nav-cta" href="/#join" data-route>Join the Waitlist</a>
    </header>
  `;
}


function $e9526c01c1b56248$export$d4b4d4d921828d81() {
    return `
    <main>
      <section class="contact-section" aria-labelledby="contact-title">
        <div class="contact-intro">
          <a class="back-link" href="/" data-route>Back</a>
          <p class="eyebrow">Enquiries</p>
          <h1 id="contact-title">Contact Us</h1>
          <p>
            Send us a note about access, partnerships, press, community questions, or anything else
            that belongs with the womyn.network team.
          </p>
        </div>

        <form
          class="interest-form contact-form"
          action="https://api.web3forms.com/submit"
          method="POST"
        >
          <input type="hidden" name="access_key" value="b72ab339-ae8e-400b-ac8c-3184f18a8c2f">
          <input type="hidden" name="subject" value="New womyn.network enquiry">
          <input type="checkbox" name="botcheck" class="botcheck" tabindex="-1" autocomplete="off">

          <div class="form-row">
            <label>
              Full name
              <input type="text" name="name" autocomplete="name" placeholder="Jane Doe" required>
            </label>

            <label>
              Email
              <input type="email" name="email" autocomplete="email" placeholder="jane@company.com" required>
            </label>
          </div>

          <label>
            What can we help with?
            <textarea
              name="message"
              rows="6"
              placeholder="Tell us about your enquiry..."
              required
            ></textarea>
          </label>

          <button class="form-submit" type="submit">Send Enquiry</button>
        </form>

        <section class="collaborator-panel" id="collaborate" aria-labelledby="collaborate-title">
          <div class="collaborator-copy">
            <p class="eyebrow">Collaborate</p>
            <h2 id="collaborate-title">Work With Us</h2>
            <p>
              For collaborators, interested investors, future team members, and specialists who
              want to help shape womyn.network.
            </p>
          </div>

          <form
            class="interest-form contact-form"
            action="https://api.web3forms.com/submit"
            method="POST"
          >
            <input type="hidden" name="access_key" value="d403e839-0a28-432f-ab6f-2f80deb1d60e">
            <input type="hidden" name="subject" value="New womyn.network collaboration enquiry">
            <input type="checkbox" name="botcheck" class="botcheck" tabindex="-1" autocomplete="off">

            <div class="form-row">
              <label>
                I am a
                <select name="collaborator_type" required>
                  <option value="">Choose one</option>
                  <option value="Collaborator">Collaborator</option>
                  <option value="Interested investor">Interested investor</option>
                  <option value="Potential team member">Potential team member</option>
                  <option value="Brand or organisation">Brand or organisation</option>
                  <option value="Specialist or advisor">Specialist or advisor</option>
                  <option value="Other">Other</option>
                </select>
              </label>

              <label>
                Specialty <span class="field-note">(if applicable)</span>
                <input type="text" name="specialty" placeholder="Product, funding, community, legal...">
              </label>
            </div>

            <label>
              Company email
              <input type="email" name="company_email" autocomplete="email" placeholder="you@company.com" required>
            </label>

            <label>
              Message
              <textarea
                name="message"
                rows="6"
                placeholder="Tell us how you would like to collaborate..."
                required
              ></textarea>
            </label>

            <button class="form-submit" type="submit">Send Collaboration Note</button>
          </form>
        </section>
      </section>
    </main>
  `;
}


var $59083e9660735393$exports = {};
$59083e9660735393$exports = import.meta.resolve("5oqTM");


var $8850bee3c2a89781$exports = {};
$8850bee3c2a89781$exports = import.meta.resolve("egmFx");


var $8d0e5eb0b11d0233$exports = {};
$8d0e5eb0b11d0233$exports = import.meta.resolve("3xS3Y");


const $05850e1a23ee861e$var$pillars = [
    {
        title: "Privacy Above All",
        icon: new URL($59083e9660735393$exports).href,
        description: "No data harvesting. No intrusive tracking. Your information and data belongs solely to you. Stay in control of your online presence with privacy-first design and features. Share only what you want, with whom you want."
    },
    {
        title: "Real, Tailored Safety",
        icon: new URL($8850bee3c2a89781$exports).href,
        description: "A rigorous verification process designed to keep the space women-only, exclusive, and safe. We are building with care around moderation, consent, and image safety to create a network where women can connect without fear of harassment or misuse."
    },
    {
        title: "Intentional Growth, Careful Curation",
        icon: new URL($8d0e5eb0b11d0233$exports).href,
        description: "Structured sharing and collaboration features within a diverse community. We're not about bots or influencers, we're about real people and real connections. "
    }
];
const $05850e1a23ee861e$var$interests = [
    "Events and Meetups",
    "Finding New Friends",
    "Wellbeing and Advice",
    "Safe Social Media",
    "Networking",
    "Other"
];
const $05850e1a23ee861e$var$heroTitles = [
    [
        {
            text: "Social networking, for "
        },
        {
            text: "women.",
            emphasis: true
        }
    ],
    [
        {
            text: "Safety isn't a feature, it's the "
        },
        {
            text: "foundation.",
            emphasis: true
        }
    ],
    [
        {
            text: "Where women come "
        },
        {
            text: "first.",
            emphasis: true
        }
    ],
    [
        {
            text: "Community",
            emphasis: true
        },
        {
            text: " matters. You belong here."
        }
    ],
    [
        {
            text: "A "
        },
        {
            text: "smarter",
            emphasis: true
        },
        {
            text: " kind of social media."
        }
    ]
];
let $05850e1a23ee861e$var$titleTimer;
var $c9b05faca41d2511$exports = {};
$c9b05faca41d2511$exports = import.meta.resolve("lTYvd");


var $7643b3f18cf0748e$exports = {};
$7643b3f18cf0748e$exports = import.meta.resolve("3j9Z3");


var $6db95cef2b6ee626$exports = {};
$6db95cef2b6ee626$exports = import.meta.resolve("3bqOb");


var $fc32e9b100fedfd5$exports = {};
$fc32e9b100fedfd5$exports = import.meta.resolve("kAou3");


var $8876d25d72885ec7$exports = {};
$8876d25d72885ec7$exports = import.meta.resolve("gof5t");


var $bb0a48f6d3d1ffab$exports = {};
$bb0a48f6d3d1ffab$exports = import.meta.resolve("hNxtk");


var $5bd9a06197584ad9$exports = {};
$5bd9a06197584ad9$exports = import.meta.resolve("5E1cK");


var $62724ec79c07d456$exports = {};
$62724ec79c07d456$exports = import.meta.resolve("j22X1");


var $fab5e4a942441041$exports = {};
$fab5e4a942441041$exports = import.meta.resolve("acFMG");



function $05850e1a23ee861e$export$29b010004a948d8() {
    return `
    <main id="home">
      <section class="hero" aria-labelledby="hero-title">
        <div class="hero-content">
          <p class="pill"><span class="status-dot" aria-hidden="true"></span>Verified applications now open</p>
          <h1 id="hero-title" class="typing-title" aria-live="polite"></h1>
          <p class="hero-copy">
            Escape the noise of traditional social media. Join a curated, women-only online
            network designed for genuine connection.
          </p>
          <div class="hero-actions">
            <a class="button primary" href="/#join" data-route>Join the Waitlist</a>
            <a class="button secondary" href="/#vision" data-route>Explore the Vision</a>
          </div>
        </div>

        <aside class="hero-art" aria-label="Community photography">
          <div class="image-frame">
            <img
              src="${new URL($c9b05faca41d2511$exports).href}"
              alt="Women gathered together in conversation"
            >
          </div>
          <div class="floating-card">
            <div class="floating-card-title">
              <img src="${new URL($7643b3f18cf0748e$exports).href}" alt="" aria-hidden="true">
              <strong>Founding Myns</strong>
            </div>
            <p>Myns are what we call our network members: join early and shape the community!</p>
          </div>
        </aside>
      </section>

      <section class="section centered" id="vision" aria-labelledby="vision-title">
        <p class="eyebrow">Our Intent</p>
        <h2 id="vision-title">Beyond the Feed</h2>
        <div class="narrow-copy">
          <p>
            womyn.network was born from the realization that modern digital spaces are often
            hostile to women. We are building more than a platform; we are constructing a dynamic,
            bustling community to support building real connections.
          </p>
        </div>

        <div class="vision-detail-grid">
          <article class="vision-detail-card">
            <h3>The Problem</h3>
            <p>
              Women are disproportionately targeted by online harassment, data theft, and image
              misuse. Too many platforms ask women to absorb the risk while treating safety as an
              afterthought.
            </p>
          </article>
          <article class="vision-detail-card">
            <h3>Privacy First Identity</h3>
            <p>
              womyn.network separates your real identity from your social presence. Myns can build
              trust through intentional verification without giving the entire internet access to
              everything about them.
            </p>
          </article>
          <article class="vision-detail-card">
            <h3>Safe Sharing</h3>
            <p>
              Your photos, posts, and conversations should belong to you. We are designing around
              consent, agency, and safer sharing from the first version of the network.
            </p>
          </article>
          <article class="vision-detail-card">
            <h3>Authentic Connections</h3>
            <p>
              No ad-first feed. No performance theatre. womyn.network is built for genuine
              interaction, thoughtful discovery, and safer spaces for women to meet online.
            </p>
          </article>
        </div>

        <div class="access-panel">
          <h3>How Access Works</h3>
          <div class="access-steps">
            <article>
              <span>01</span>
              <h4>Secure an Invite</h4>
              <p>womyn.network is invite-only to keep the space intentional, safer, and high trust.</p>
            </article>
            <article>
              <span>02</span>
              <h4>Choose Your Username</h4>
              <p>Create a unique handle before joining the wider community and building your profile.</p>
            </article>
            <article>
              <span>03</span>
              <h4>Become a Myn</h4>
              <p>Access the feed, save your favorite posts, join discussions, chat, and make new friends.</p>
            </article>
          </div>
        </div>

        <div class="ethics-note">
          <p>
            womyn.network prioritises women's agency. We are building with care around data,
            consent, image safety, and moderation because nobody should have their identity or
            photos used without permission.
          </p>
        </div>
      </section>

      <section class="section soft" id="pillars" aria-labelledby="pillars-title">
        <div class="split-heading">
          <div>
            <h2 id="pillars-title">The Pillars of Our Ethos</h2>
            <p>
              Our architecture is built on foundations that ensure every myn feels seen, heard,
              and protected.
            </p>
          </div>
          <a class="learn-more-link" href="/contact" data-route>
            Learn More
            <img src="${new URL($6db95cef2b6ee626$exports).href}" alt="" aria-hidden="true">
          </a>
        </div>

        <div class="interest-grid" id="interestGrid"></div>
      </section>

      <section class="section connect-section" aria-labelledby="connect-title">
        <p class="eyebrow">Ways to Connect</p>
        <h2 id="connect-title">A first step toward the network people actually need.</h2>
        <p class="connect-description">
          womyn.network is invite-only because belonging should feel intentional. Every myn is
          vetted before joining, creating a more trusted space where access feels earned,
          introductions feel safer, and the network stays high-signal as it grows.
        </p>

        <div class="feature-carousel" aria-label="Network features">
          <div class="feature-track">
            ${[
        "create Circles",
        "share posts safely",
        "follow your friends",
        "meet new Myns",
        "connect across the country",
        "get advice",
        "share your thoughts safely",
        "feel welcome",
        "meet new people",
        "find thoughtful support",
        "build trusted connections",
        "have fun with new friends"
    ].concat([
        "create Circles",
        "share posts safely",
        "follow your friends",
        "meet new Myns",
        "connect across the country",
        "get advice",
        "share your thoughts safely",
        "feel welcome",
        "meet new people",
        "find thoughtful support",
        "build trusted connections",
        "have fun with new friends"
    ]).map((feature, index)=>`<span${index > 11 ? ' aria-hidden="true"' : ""}>${feature}</span>`).join("")}
          </div>
        </div>
      </section>

      <section class="section founding" id="founding" aria-labelledby="founding-title">
        <div class="placeholder-collage" aria-label="Founding myn photography">
          <div class="portrait-placeholder collage-image">
            <img src="${new URL($fc32e9b100fedfd5$exports).href}" alt="Portrait of a woman">
          </div>
          <div class="wide-placeholder collage-image">
            <img src="${new URL($8876d25d72885ec7$exports).href}" alt="A group gathered together">
          </div>
          <div class="wide-placeholder collage-image">
            <img src="${new URL($bb0a48f6d3d1ffab$exports).href}" alt="Mentoring conversation at a table">
          </div>
        </div>

        <div class="founding-copy">
          <span class="rule"></span>
          <h2 id="founding-title">Shape the Network's Future</h2>
          <p>
            Our founding myns are more than early users; they are the architects of our culture.
            By joining now, you can influence platform features and community guidelines.
          </p>

          <ul class="benefit-list">
            <li>
              <img class="benefit-icon" src="${new URL($5bd9a06197584ad9$exports).href}" alt="" aria-hidden="true">
              <strong>Founding Myn Badge</strong>
              <span>A permanent mark of distinction on your profile.</span>
            </li>
            <li>
              <img class="benefit-icon" src="${new URL($62724ec79c07d456$exports).href}" alt="" aria-hidden="true">
              <strong>Early Beta Access</strong>
              <span>Access tools and features before the wider rollout.</span>
            </li>
            <li>
              <img class="benefit-icon" src="${new URL($fab5e4a942441041$exports).href}" alt="" aria-hidden="true">
              <strong>Real Influence</strong>
              <span>Vote on community initiatives and platform direction.</span>
            </li>
          </ul>

          <a class="button secondary" href="/#join" data-route>Become a Founding Myn today!</a>
        </div>
      </section>

      <section class="section join-section" id="join" aria-labelledby="join-title">
        <div class="join-content-wrapper">
          <form
          class="interest-form"
          id="interestForm"
          action="https://api.web3forms.com/submit"
          method="POST"
        >
          <input type="hidden" name="access_key" value="b72ab339-ae8e-400b-ac8c-3184f18a8c2f">
          <input type="hidden" name="subject" value="New womyn.network waitlist interest">
          <input type="checkbox" name="botcheck" class="botcheck" tabindex="-1" autocomplete="off">

          <div class="form-heading">
            <div class="invite-callout" aria-label="Invite code bonus">
              <span>Join now and get</span>
              <strong>+20 invite codes!</strong>
            </div>
            <h2 id="join-title">Claim Your Place</h2>
            <p>We curate our waitlist to maintain the quality of the network.</p>
          </div>

          <div class="form-row">
            <label>
              Name
              <input type="text" name="name" autocomplete="name" placeholder="Jane Doe" required>
            </label>
            <label>
              Email
              <input type="email" name="email" autocomplete="email" placeholder="jane@company.com">
            </label>
          </div>

          <div class="form-row">
            <label>
              Social platform
              <select name="social_platform">
                <option value="">Choose one</option>
                <option value="Instagram">Instagram</option>
                <option value="TikTok">TikTok</option>
                <option value="Facebook">Facebook</option>
                <option value="Discord">Discord</option>
                <option value="LinkedIn">LinkedIn</option>
              </select>
            </label>
            <label>
              Handle
              <input type="text" name="social_handle" placeholder="@yourhandle">
            </label>
          </div>

          <label class="label-with-note">
            <span>Location <span class="field-note">(optional)</span></span>
            <input type="text" name="location" autocomplete="address-level2" placeholder="Nearest city near you">
          </label>

          <fieldset>
            <legend>Interest areas</legend>
            <div class="checkbox-list" id="interestOptions"></div>
            <p class="form-helper">If Other please specify below!</p>
          </fieldset>

          <label>
            What are you looking for?
            <textarea
              name="message"
              rows="5"
              placeholder="Tell us what would make this network valuable for you..."
              required
            ></textarea>
          </label>

          <label class="info-checkbox">
            <input type="checkbox" name="wants_more_info" value="Yes">
            <span>
              Not sure yet? No worries! We're reaching out to every applicant. If you want more
              info before registering for official verification, tick this box and we'll have a
              chat &lt;3
            </span>
          </label>

          <button class="form-submit" type="submit">Apply to Join</button>
          <p class="form-status" id="formStatus" role="status" aria-live="polite"></p>
        </form>

        <a class="collab-callout" href="/contact#collaborate" data-route>
          <strong>Interested in collaborating?</strong>
          <span>
            We're expanding. Fill out this form
            <img src="${new URL($6db95cef2b6ee626$exports).href}" alt="" aria-hidden="true">
          </span>
        </a>
        </div>
      </section>

      <section class="section faq" id="faq" aria-labelledby="faq-title">
        <div class="section-heading centered-heading" style="position: relative;">
          <a class="faq-callout" href="/contact" data-route>
            <strong>Got more questions?</strong>
            <span>Reach out &lt;3</span>
          </a>
          <h2 id="faq-title">Common Enquiries</h2>
          <span class="title-underline"></span>
        </div>

        <div class="faq-list">
          <article>
            <h3>How is the platform kept exclusive and verified?</h3>
            <p>
              We are still shaping the verification approach and gathering interest from people who
              want a safer, more intentional professional space. Verification will involve a mix of social media vetting, reference checks, and manual review to ensure a trusted community!
            </p>
          </article>
          <article>
            <h3>What makes this different from other social medias?</h3>
            <p>
              The focus is depth of connection and shared experience without the performative noise
              of traditional feeds. No ads, no data harvesting, and a design built around consent and safety from the ground up. You're not a product, you're a myn <3
            </p>
          </article>
          <article>
            <h3>When will the network launch?</h3>
            <p>
              Signing up the verification waitlist is the first step. Responses will guide the beta timeline and
              first myn experience. We're moving fast, but we want to get it right, so sign up to our mailing list for updates and announcements as we get closer to launch!
            </p>
          </article>
        </div>
      </section>

      <section class="newsletter-section" aria-labelledby="newsletter-title">
        <div class="newsletter-inner">
          <div>
            <p class="eyebrow">Stay close</p>
            <h2 id="newsletter-title">Subscribe to the newsletter</h2>
            <p>
              Get founding updates, community notes, and early access announcements as
              womyn.network takes shape. We'll also share info on upcoming events and opportunities to connect with other myns as we build!
            </p>
          </div>
          <div class="newsletter-form" id="newsletterForm"></div>
        </div>
      </section>
    </main>
  `;
}
function $05850e1a23ee861e$export$162345c65a26dc93() {
    $05850e1a23ee861e$var$renderPillars();
    $05850e1a23ee861e$var$renderInterestOptions();
    $05850e1a23ee861e$var$startTitleTyping();
    $05850e1a23ee861e$var$bindWaitlistForm();
    $05850e1a23ee861e$var$loadBeehiivForm();
}
function $05850e1a23ee861e$var$renderPillars() {
    const interestGrid = document.querySelector("#interestGrid");
    if (!interestGrid) return;
    interestGrid.innerHTML = $05850e1a23ee861e$var$pillars.map((pillar)=>`
        <article class="interest-card">
          <span aria-hidden="true">
            <img src="${pillar.icon}" alt="">
          </span>
          <h3>${pillar.title}</h3>
          <p>${pillar.description}</p>
        </article>
      `).join("");
}
function $05850e1a23ee861e$var$renderInterestOptions() {
    const interestOptions = document.querySelector("#interestOptions");
    if (!interestOptions) return;
    interestOptions.innerHTML = $05850e1a23ee861e$var$interests.map((interest)=>`
        <label>
          <input type="checkbox" name="interests[]" value="${interest}">
          ${interest}
        </label>
      `).join("");
}
function $05850e1a23ee861e$var$bindWaitlistForm() {
    const interestForm = document.querySelector("#interestForm");
    const formStatus = document.querySelector("#formStatus");
    if (!interestForm) return;
    interestForm.addEventListener("submit", (event)=>{
        const formData = new FormData(interestForm);
        const selectedInterests = formData.getAll("interests[]");
        const email = formData.get("email").trim();
        const socialHandle = formData.get("social_handle").trim();
        const socialPlatform = formData.get("social_platform");
        if (selectedInterests.length === 0) {
            event.preventDefault();
            formStatus.textContent = "Please choose at least one interest area.";
            return;
        }
        if (!email && !socialHandle) {
            event.preventDefault();
            formStatus.textContent = "Please add an email or social handle so we can reach you.";
            return;
        }
        if (socialHandle && !socialPlatform) {
            event.preventDefault();
            formStatus.textContent = "Please choose a social platform for your handle.";
        }
    });
}
function $05850e1a23ee861e$var$getTitleText(parts) {
    return parts.map((part)=>part.text).join("");
}
function $05850e1a23ee861e$var$renderTypedTitle(parts, characterCount) {
    const typingTitle = document.querySelector("#hero-title");
    if (!typingTitle) return;
    typingTitle.replaceChildren();
    let remainingCharacters = characterCount;
    parts.forEach((part)=>{
        if (remainingCharacters <= 0) return;
        const text = part.text.slice(0, remainingCharacters);
        const node = part.emphasis ? document.createElement("span") : document.createTextNode(text);
        if (part.emphasis) node.textContent = text;
        typingTitle.append(node);
        remainingCharacters -= text.length;
    });
}
function $05850e1a23ee861e$var$startTitleTyping() {
    if (!document.querySelector("#hero-title")) return;
    window.clearTimeout($05850e1a23ee861e$var$titleTimer);
    let titleIndex = 0;
    let characterCount = 0;
    let isDeleting = false;
    let completedTitles = 0;
    const totalAnimatedTitles = $05850e1a23ee861e$var$heroTitles.length * 2;
    function tick() {
        const title = $05850e1a23ee861e$var$heroTitles[titleIndex];
        const fullLength = $05850e1a23ee861e$var$getTitleText(title).length;
        $05850e1a23ee861e$var$renderTypedTitle(title, characterCount);
        if (!isDeleting && characterCount < fullLength) {
            characterCount += 1;
            $05850e1a23ee861e$var$titleTimer = window.setTimeout(tick, 105);
            return;
        }
        if (!isDeleting && characterCount === fullLength) {
            completedTitles += 1;
            if (window.innerWidth <= 720 && titleIndex === 0) return;
            if (completedTitles > totalAnimatedTitles && titleIndex === 0) return;
            isDeleting = true;
            $05850e1a23ee861e$var$titleTimer = window.setTimeout(tick, 3600);
            return;
        }
        if (isDeleting && characterCount > 0) {
            characterCount -= 1;
            $05850e1a23ee861e$var$titleTimer = window.setTimeout(tick, 58);
            return;
        }
        titleIndex = completedTitles >= totalAnimatedTitles ? 0 : (titleIndex + 1) % $05850e1a23ee861e$var$heroTitles.length;
        isDeleting = false;
        $05850e1a23ee861e$var$titleTimer = window.setTimeout(tick, 650);
    }
    tick();
}
function $05850e1a23ee861e$var$loadBeehiivForm() {
    const newsletterForm = document.querySelector("#newsletterForm");
    if (!newsletterForm) return;
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://subscribe-forms.beehiiv.com/v3/loader.js";
    script.dataset.beehiivForm = "c4de236e-28fd-47cf-a08f-25b4d8adadff";
    newsletterForm.replaceChildren(script);
}


function $884602fc301131ed$export$6536140195e2ff68() {
    return `
    <main>
      <section class="contact-section">
        <div class="contact-intro">
          <p class="eyebrow">404</p>
          <h1>Page Not Found</h1>
          <p>This page is not available yet.</p>
          <a class="back-link" href="/" data-route>Back home</a>
        </div>
      </section>
    </main>
  `;
}


function $cefe321e89d3b07a$export$fb2b63965de9641e() {
    return `
    <main id="terms" class="legal-page section narrow-copy">
      <a class="back-link" href="/" data-route>Back to home</a>
      <div class="contact-intro">
        <p class="eyebrow">Legal</p>
        <h1>Terms of Use</h1>
      </div>
      <div class="terms-content">
        <p><strong>Effective:</strong> 2026<br>
        <strong>Last updated:</strong> 22 April 2026</p>

        <p>Welcome to womyn.network. These Terms of Use govern your access to and use of the womyn.network website, platform, features, and related content (the "Service"). By accessing, browsing, creating an account, or using the Service, you agree to be bound by these Terms. If you do not agree, you must not use womyn.network.</p>

        <h3>1. About womyn.network</h3>
        <p>womyn.network is a women-only digital platform designed around privacy, safety, trust, and more relaxed social connection in a women-centred online space.</p>
        <p>The Service may include community spaces, social posting features, profiles, moderation tools, chat features, privacy-protective design features, experimental safety technologies, and prototype or beta functionality.</p>

        <h3>2. Eligibility</h3>
        <p>To use the Service, you must:</p>
        <ul>
          <li>be at least 18 years old; and</li>
          <li>meet the platform's women-only eligibility rule set out below.</li>
        </ul>
        <p>womyn.network is intended exclusively for adult women. By creating an account or using the Service, you confirm that you meet this requirement and that the information you provide to us is accurate.</p>
        <p>This women-only rule is a core condition of access to the Service. It is part of the platform's purpose, design, moderation model, and safeguarding approach.</p>
        <p>We reserve the right to refuse access, suspend accounts, request additional information, or remove users where we reasonably believe this eligibility requirement is not met or has been circumvented.</p>

        <h3>3. Purpose of the women-only rule</h3>
        <p>womyn.network was created to provide a dedicated women-centred space shaped by women's privacy, safety, dignity, and ability to interact more freely online.</p>
        <p>We maintain this boundary because we consider it central to the platform's purpose and to the integrity of the environment we are building.</p>

        <h3>4. Beta status</h3>
        <p>womyn.network may be offered in beta or prototype form.</p>
        <p>This means that parts of the Service may be incomplete, experimental, changed, interrupted, or removed at any time. Features may not work as expected. We do not guarantee uninterrupted availability, permanent access, compatibility with all devices, or that any part of the Service will remain available in its current form.</p>
        <p>By using a beta product, you understand that you may encounter bugs, errors, outages, design changes, and unfinished functionality.</p>

        <h3>5. Your account</h3>
        <p>You are responsible for your account and for keeping your login details secure.</p>
        <p>You agree not to:</p>
        <ul>
          <li>create an account using false or misleading information;</li>
          <li>impersonate another person;</li>
          <li>share your account with anyone else;</li>
          <li>attempt to access another user's account; or</li>
          <li>use the Service in a way that undermines the safety, integrity, or intended membership boundary of the platform.</li>
        </ul>
        <p>You can and must notify us promptly at hello@womyn.network if you believe your account has been compromised.</p>

        <h3>6. Acceptable use & Chat</h3>
        <p>You agree to use womyn.network respectfully and safely.</p>
        <p>You must not use the Service to:</p>
        <ul>
          <li>harass, threaten, stalk, intimidate, or abuse others;</li>
          <li>upload, post, send, or share harmful, defamatory, obscene, sexually exploitative, or hateful material;</li>
          <li>share another person's private, confidential, or intimate information without permission;</li>
          <li>post non-consensual intimate images or material intended to humiliate, exploit, or endanger another person;</li>
          <li>impersonate another person or misrepresent your identity;</li>
          <li>misuse the chat features to send unsolicited mass messages, spam, or share private conversations without consent;</li>
          <li>collect data from other users without permission;</li>
          <li>spam, scam, phish, or distribute malware;</li>
          <li>test, probe, reverse engineer, interfere with, or disrupt the Service or its security;</li>
          <li>bypass moderation, safety systems, account restrictions, or access controls;</li>
          <li>use the platform for commercial scraping, mass messaging, or unauthorised advertising; or</li>
          <li>upload content that infringes copyright, trade marks, privacy, or other rights.</li>
        </ul>
        <p>We may remove content or restrict access where we reasonably believe use of the Service breaches these Terms or creates risk for users or the platform.</p>

        <h3>7. Community safety and moderation</h3>
        <p>womyn.network is a moderated platform. We review accounts, posts, messages, reports, or other activity where reasonably necessary to:</p>
        <ul>
          <li>enforce these Terms;</li>
          <li>maintain the women-only rule;</li>
          <li>investigate misuse, safety incidents, or fraud; and</li>
          <li>protect users, staff, or the Service.</li>
        </ul>
        <p>Moderation may include warnings, content removal, temporary restrictions, suspension, or permanent account termination.</p>
        <p>We are not obliged to host, publish, restore, or maintain any particular content, account, username, feature, or community space at this stage.</p>

        <h3>8. User content</h3>
        <p>You retain ownership of the content you create and upload to womyn.network, subject to any rights in third-party material included in that content.</p>
        <p>You are responsible for the content you post and confirm that you have the rights needed to post it.</p>

        <h3>9. Privacy-protective and AI-related features</h3>
        <p>womyn.network may include privacy or safety technologies designed to reduce misuse of shared images or content, including experimental browser-side AI protective processing.</p>
        <p>Where such features are offered, they are intended to support user privacy and safety, but they are not guaranteed to prevent copying, manipulation, extraction, scraping, or malicious reuse.</p>
        <p>You remain responsible for deciding what you choose to upload or share.</p>

        <h3>10. Reporting content or users</h3>
        <p>If you believe content, chat messages, or behaviour on the Service breaches these Terms or creates a safety concern, you can report it by contacting hello@womyn.network.</p>
        <p>We may investigate reports but do not guarantee any particular outcome, timeframe, or response.</p>

        <h3>11. Suspension and termination</h3>
        <p>We may suspend, restrict, or terminate your access to all or part of the Service at any time where we reasonably believe that:</p>
        <ul>
          <li>you have breached these Terms;</li>
          <li>you do not meet the eligibility requirements;</li>
          <li>your use creates security or safety risks;</li>
          <li>doing so is necessary to protect the community, the platform, or third parties; or</li>
          <li>we are changing, pausing, or discontinuing the Service.</li>
        </ul>
        <p>You may stop using the Service at any time.</p>

        <h3>12. Intellectual property</h3>
        <p>All rights in womyn.network, other than user content, belong to us or our licensors. This includes the platform name, branding, software, design, text, graphics, interfaces, databases, and site content.</p>
        <p>You may not copy, modify, distribute, sell, or exploit any part of the Service except with our written permission.</p>

        <h3>13. Third-party services and links</h3>
        <p>The Service may contain links to third-party websites, tools, libraries, or services. We are not responsible for third-party content, availability, policies, or practices.</p>

        <h3>14. Service availability</h3>
        <p>We do not guarantee that womyn.network will always be available, error-free, or compatible with your device or browser.</p>
        <p>Access may be suspended or limited for maintenance, updates, security reasons, moderation, or technical issues.</p>

        <h3>15. Changes to these Terms</h3>
        <p>We may update these Terms from time to time.</p>
        <p>Where changes are material, we will take reasonable steps to notify users, such as by updating the date above, posting a notice on the Service, or contacting users through the platform or by email.</p>
        <p>Your continued use of the Service after updated Terms take effect means you accept the revised Terms.</p>

        <h3>Contact</h3>
        <p>If you have questions about these Terms, please contact:</p>
        <p><strong>Email:</strong> hello@womyn.network</p>

        <p><em>This page is intended as platform policy and product copy. Before launch, the final wording will be reviewed by a qualified professional.</em></p>
      </div>
    </main>
  `;
}


const $637d1d8ec28916b7$var$routes = {
    "/": {
        title: "womyn.network | Join Today",
        render: (0, $05850e1a23ee861e$export$29b010004a948d8),
        afterRender: (0, $05850e1a23ee861e$export$162345c65a26dc93)
    },
    "/contact": {
        title: "womyn.network | Contact Us",
        render: (0, $e9526c01c1b56248$export$d4b4d4d921828d81)
    },
    "/terms": {
        title: "womyn.network | Beta Terms",
        render: (0, $cefe321e89d3b07a$export$fb2b63965de9641e)
    }
};
let $637d1d8ec28916b7$var$app;
function $637d1d8ec28916b7$export$cf7ee87ede64229c() {
    $637d1d8ec28916b7$var$app = document.querySelector("#app");
    if (!$637d1d8ec28916b7$var$app) return;
    window.addEventListener("popstate", ()=>$637d1d8ec28916b7$var$renderCurrentRoute());
    document.addEventListener("click", $637d1d8ec28916b7$var$handleRouteClick);
    $637d1d8ec28916b7$var$renderCurrentRoute();
}
function $637d1d8ec28916b7$var$handleRouteClick(event) {
    const link = event.target.closest("a[data-route]");
    if (!link) return;
    const url = new URL(link.getAttribute("href"), window.location.origin);
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    history.pushState({}, "", `${url.pathname}${url.hash}`);
    $637d1d8ec28916b7$var$renderCurrentRoute();
}
function $637d1d8ec28916b7$var$renderCurrentRoute() {
    const path = $637d1d8ec28916b7$var$normalizePath(window.location.pathname);
    const route = $637d1d8ec28916b7$var$routes[path] || {
        title: "womyn.network | Page Not Found",
        render: (0, $884602fc301131ed$export$6536140195e2ff68)
    };
    document.title = route.title;
    $637d1d8ec28916b7$var$app.innerHTML = `${(0, $95d0977e6dbb0c2a$export$5072548dc819e0ba)()}${route.render()}${(0, $3e595d6bb3c29eb5$export$f78842bd8df93f12)()}`;
    $637d1d8ec28916b7$var$bindMenuToggle();
    $637d1d8ec28916b7$var$updateActiveNav();
    route.afterRender?.();
    $637d1d8ec28916b7$var$scrollToCurrentHash();
}
function $637d1d8ec28916b7$var$bindMenuToggle() {
    const toggle = document.querySelector(".menu-toggle");
    const menu = document.querySelector("#primaryNav");
    if (!toggle || !menu) return;
    toggle.addEventListener("click", ()=>{
        const isOpen = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!isOpen));
        menu.classList.toggle("is-open", !isOpen);
    });
}
function $637d1d8ec28916b7$var$updateActiveNav() {
    const currentPath = $637d1d8ec28916b7$var$normalizePath(window.location.pathname);
    const currentHash = window.location.hash;
    const navLinks = document.querySelectorAll(".nav-menu a");
    navLinks.forEach((link)=>{
        const url = new URL(link.getAttribute("href"), window.location.origin);
        const linkPath = $637d1d8ec28916b7$var$normalizePath(url.pathname);
        const matchesContact = currentPath === "/contact" && linkPath === "/contact";
        const matchesHash = currentPath === "/" && linkPath === "/" && currentHash && url.hash === currentHash;
        link.classList.toggle("is-active", matchesContact || matchesHash);
    });
}
function $637d1d8ec28916b7$var$scrollToCurrentHash() {
    if (!window.location.hash) {
        window.scrollTo({
            top: 0,
            behavior: "auto"
        });
        return;
    }
    const target = document.querySelector(window.location.hash);
    if (target) target.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
}
function $637d1d8ec28916b7$var$normalizePath(pathname) {
    if (pathname === "/" || pathname === "/index.html") return "/";
    return pathname.replace(/\/$/, "");
}



(0, $637d1d8ec28916b7$export$cf7ee87ede64229c)();


//# sourceMappingURL=path0.22b4125d.js.map
